import { css } from "styled-components";
import { getThemeData, createStyleComponent } from "@hzero-front-ui/core/lib/utils";
import { getBorder } from "./Select.style";
var getCascaderDropdown = function getCascaderDropdown(props) {
  var _getThemeData = getThemeData(props, "select"),
    fontFamily = _getThemeData.fontFamily,
    activeBgColor = _getThemeData.activeBgColor,
    activeFontWeight = _getThemeData.activeFontWeight,
    hoverBgColor = _getThemeData.hoverBgColor,
    dropdownWrapperBorderColor = _getThemeData.dropdownWrapperBorderColor;
  var _getThemeData2 = getThemeData(props, "cascader"),
    _getThemeData2$rightI = _getThemeData2.rightItemHeight,
    rightItemHeight = _getThemeData2$rightI === void 0 ? "" : _getThemeData2$rightI,
    _getThemeData2$noShad = _getThemeData2.noShadow,
    noShadow = _getThemeData2$noShad === void 0 ? false : _getThemeData2$noShad,
    _getThemeData2$column = _getThemeData2.columnGap,
    columnGap = _getThemeData2$column === void 0 ? 8 : _getThemeData2$column,
    _getThemeData2$column2 = _getThemeData2.columnBorder,
    columnBorder = _getThemeData2$column2 === void 0 ? "none" : _getThemeData2$column2,
    _getThemeData2$column3 = _getThemeData2.columnShadow,
    columnShadow = _getThemeData2$column3 === void 0 ? "0 1px 3px 0 rgba(0,0,0,0.20)" : _getThemeData2$column3,
    itemHeight = _getThemeData2.itemHeight;
  return css([".ant-cascader-menus.ant-cascader-menus{box-shadow:", ";> div{}border-radius:2px;.ant-cascader-menu{& + .ant-cascader-menu{height:", ";margin-left:", "px;}border:", ";box-shadow:", ";border-radius:0.02px;position:relative;background:#fff;z-index:10;.ant-cascader-menu-item{font-family:", ";padding:", "px 8px;:hover{background-color:", ";}&-active{background-color:", ";font-weight:", ";}}}}"], noShadow ? "none" : "", rightItemHeight, columnGap, columnBorder, columnShadow, fontFamily, (itemHeight - 22) / 2, hoverBgColor, activeBgColor, activeFontWeight);
};
var getCascaderStyle = function getCascaderStyle(props) {
  var _getThemeData3 = getThemeData(props, "input"),
    radius = _getThemeData3.radius,
    disabledBorderColor = _getThemeData3.disabledBorderColor;
  var _getThemeData4 = getThemeData(props, "common"),
    baseHeight = _getThemeData4.baseHeight;
  return css([".ant-cascader-picker{height:", "px;border-radius:", "px;border:none;", ";&&:focus{.ant-input{box-shadow:none;}}&.ant-cascader-picker-disabled{border-color:", ";}:focus{.ant-input{box-shadow:none;}}.ant-input{border:none;height:", "px;border-radius:", "px;}}", ""], baseHeight, radius, getBorder, disabledBorderColor, baseHeight - 2, radius - 2, getCascaderDropdown);
};
export default createStyleComponent("cascader", getCascaderStyle);